// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/bg1.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  position: relative;
}

.login-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.2;
  z-index: 0;
}

.login-card {
  background: rgba(26, 26, 46, 0.85);
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  padding: 40px;
  width: 100%;
  max-width: 400px;
  position: relative;
  z-index: 1;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.login-card h1 {
  margin: 0 0 8px;
  color: #eaeaea;
  font-size: 28px;
  font-weight: 600;
}

.login-card p {
  color: #aaa;
  margin: 0 0 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #eaeaea;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #333;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.1);
  color: #eaeaea;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
}

.form-group input::placeholder {
  color: #888;
}

.btn-primary {
  width: 100%;
  padding: 14px;
  background: rgba(102, 126, 234, 0.9);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  background: rgba(102, 126, 234, 1);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-link {
  background: none;
  border: none;
  color: #7a9fff;
  cursor: pointer;
  font-size: 14px;
  padding: 10px;
  width: 100%;
}

.btn-link:hover {
  text-decoration: underline;
}

.error-message {
  background: rgba(233, 69, 96, 0.2);
  border: 1px solid rgba(233, 69, 96, 0.5);
  color: #e94560;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
}

.login-footer {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.login-footer p {
  margin: 0;
  color: #aaa;
}

.login-footer a {
  color: #7a9fff;
  text-decoration: none;
  font-weight: 500;
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper input {
  padding-right: 40px;
}

.password-input-wrapper .password-toggle {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  padding: 0;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
}

.password-input-wrapper .password-toggle:hover {
  color: #eaeaea;
}

.forgot-password-link {
  background: none;
  border: none;
  color: #7a9fff;
  cursor: pointer;
  font-size: 14px;
  padding: 8px 0 0 0;
  margin-top: 4px;
  transition: color 0.2s;
}

.forgot-password-link:hover {
  color: #667eea;
  text-decoration: underline;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-content {
  background: rgba(26, 26, 46, 0.95);
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 380px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.modal-header h3 {
  margin: 0;
  color: #eaeaea;
  font-size: 18px;
  font-weight: 600;
}

.modal-header .close-btn {
  background: none;
  border: none;
  color: #888;
  font-size: 20px;
  cursor: pointer;
  padding: 4px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s, color 0.2s;
}

.modal-header .close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #eaeaea;
}

.modal-body {
  padding: 24px;
}

.modal-body p {
  color: #aaa;
  margin: 0 0 16px;
  font-size: 14px;
}

.mail-icon {
  position: absolute;
  right: 12px;
  color: #888;
  width: 20px;
  height: 20px;
}

.forgot-message {
  margin-top: 12px;
  padding: 10px;
  border-radius: 6px;
  font-size: 13px;
  text-align: center;
}

.forgot-message.success {
  background: rgba(39, 174, 96, 0.2);
  color: #27ae60;
}

.forgot-message.error {
  background: rgba(233, 69, 96, 0.2);
  color: #e94560;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.btn-secondary {
  padding: 10px 20px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #eaeaea;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

@media (max-width: 480px) {
  .login-card {
    padding: 30px 20px;
    max-width: 95%;
  }

  .login-card h1 {
    font-size: 24px;
  }

  .form-group {
    margin-bottom: 16px;
  }

  .form-group input {
    padding: 10px 14px;
    font-size: 13px;
  }

  .btn-primary {
    padding: 12px;
    font-size: 15px;
  }
}

@media (max-width: 360px) {
  .login-card {
    padding: 25px 16px;
  }

  .login-card h1 {
    font-size: 22px;
  }

  .password-input-wrapper input {
    padding-right: 36px;
  }

  .password-input-wrapper .password-toggle {
    width: 26px;
    height: 26px;
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yDAAkD;EAClD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;EACtB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  padding: 20px;\n  position: relative;\n}\n\n.login-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: url('../assets/images/bg1.jpeg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  opacity: 0.2;\n  z-index: 0;\n}\n\n.login-card {\n  background: rgba(26, 26, 46, 0.85);\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  padding: 40px;\n  width: 100%;\n  max-width: 400px;\n  position: relative;\n  z-index: 1;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.login-card h1 {\n  margin: 0 0 8px;\n  color: #eaeaea;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.login-card p {\n  color: #aaa;\n  margin: 0 0 24px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: #eaeaea;\n  font-weight: 500;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #333;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.3s;\n  box-sizing: border-box;\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #eaeaea;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.form-group input::placeholder {\n  color: #888;\n}\n\n.btn-primary {\n  width: 100%;\n  padding: 14px;\n  background: rgba(102, 126, 234, 0.9);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n  background: rgba(102, 126, 234, 1);\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-link {\n  background: none;\n  border: none;\n  color: #7a9fff;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 10px;\n  width: 100%;\n}\n\n.btn-link:hover {\n  text-decoration: underline;\n}\n\n.error-message {\n  background: rgba(233, 69, 96, 0.2);\n  border: 1px solid rgba(233, 69, 96, 0.5);\n  color: #e94560;\n  padding: 12px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.login-footer {\n  text-align: center;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.login-footer p {\n  margin: 0;\n  color: #aaa;\n}\n\n.login-footer a {\n  color: #7a9fff;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper input {\n  padding-right: 40px;\n}\n\n.password-input-wrapper .password-toggle {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0;\n  color: #888;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n}\n\n.password-input-wrapper .password-toggle:hover {\n  color: #eaeaea;\n}\n\n.forgot-password-link {\n  background: none;\n  border: none;\n  color: #7a9fff;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 8px 0 0 0;\n  margin-top: 4px;\n  transition: color 0.2s;\n}\n\n.forgot-password-link:hover {\n  color: #667eea;\n  text-decoration: underline;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.modal-content {\n  background: rgba(26, 26, 46, 0.95);\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  width: 90%;\n  max-width: 380px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #eaeaea;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.modal-header .close-btn {\n  background: none;\n  border: none;\n  color: #888;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background 0.2s, color 0.2s;\n}\n\n.modal-header .close-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #eaeaea;\n}\n\n.modal-body {\n  padding: 24px;\n}\n\n.modal-body p {\n  color: #aaa;\n  margin: 0 0 16px;\n  font-size: 14px;\n}\n\n.mail-icon {\n  position: absolute;\n  right: 12px;\n  color: #888;\n  width: 20px;\n  height: 20px;\n}\n\n.forgot-message {\n  margin-top: 12px;\n  padding: 10px;\n  border-radius: 6px;\n  font-size: 13px;\n  text-align: center;\n}\n\n.forgot-message.success {\n  background: rgba(39, 174, 96, 0.2);\n  color: #27ae60;\n}\n\n.forgot-message.error {\n  background: rgba(233, 69, 96, 0.2);\n  color: #e94560;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.btn-secondary {\n  padding: 10px 20px;\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  color: #eaeaea;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n@media (max-width: 480px) {\n  .login-card {\n    padding: 30px 20px;\n    max-width: 95%;\n  }\n\n  .login-card h1 {\n    font-size: 24px;\n  }\n\n  .form-group {\n    margin-bottom: 16px;\n  }\n\n  .form-group input {\n    padding: 10px 14px;\n    font-size: 13px;\n  }\n\n  .btn-primary {\n    padding: 12px;\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 360px) {\n  .login-card {\n    padding: 25px 16px;\n  }\n\n  .login-card h1 {\n    font-size: 22px;\n  }\n\n  .password-input-wrapper input {\n    padding-right: 36px;\n  }\n\n  .password-input-wrapper .password-toggle {\n    width: 26px;\n    height: 26px;\n    font-size: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
